import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { IGetLanguages } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getLanguages } from 'backend/additionalInformation';
import { useTranslation } from 'react-i18next';

interface ILanguagesMultipleSelect {
	setCustomerLanguages: (value: string[]) => void;
	IDSelectedCustomerDefaultLanguage: Nullable<string>;
	IDsSelectedCustomerLanguages: string[];
}

const LanguagesMultipleSelect: React.FC<ILanguagesMultipleSelect> = ({
	IDSelectedCustomerDefaultLanguage,
	IDsSelectedCustomerLanguages,
	setCustomerLanguages,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetLanguages, null>(getLanguages);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('selectOneLanguage') },
			() => ({
				validator() {
					if (
						IDSelectedCustomerDefaultLanguage &&
						IDsSelectedCustomerLanguages.includes(IDSelectedCustomerDefaultLanguage)
					) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('mustContainDefaultLanguage')));
				},
			}),
		],
		[IDSelectedCustomerDefaultLanguage, IDsSelectedCustomerLanguages, t],
	);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.languages.map((el) => ({
				id: el.id,
				name: tForm(el.name),
			})) || []
		);
	}, [tForm, response]);

	return (
		<FormSelect
			testId="LanguagesMultipleSelect"
			name="IDsSelectedCustomerLanguages"
			label="languagesLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setCustomerLanguages}
			validationRules={validationRules}
			mode="multiple"
			showSearch={false}
		/>
	);
};

export default React.memo(LanguagesMultipleSelect);
